import { Reducer } from '@reduxjs/toolkit';

const appLayerSettingsReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { layerSettings: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, layerSettings: payload };
};

export default appLayerSettingsReducer;
